(function(){
  'use strict';

  angular
    .module('app')
    .component('preloader', preloaderComponent());

  function preloaderComponent() {
    return {
      template: `<div class="d-flex justify-content-center h-100" ng-if="vm.hide">
					<div class="p-2 align-self-center">
						<img src="media/preloader-white.svg" ng-if="vm.dark" />
						<img src="media/preloader.svg" ng-if="!vm.dark" />
					</div>
				</div>`,
      bindings: {hide: '=', dark: '='},
      controller: PreloaderController,
      controllerAs: 'vm',
      transclude: false
    }
  }

  function PreloaderController() {
    let vm = this;
  }

})();
